var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-description"},_vm._l((_vm.currentDescriptions),function(description,index){return _c('div',{key:index},[_c('p',{staticClass:"my-2"},[_vm._v(_vm._s(description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }